// 综合评估
const Evaluation = () => import('./')
// 综合评估入口列表
const EvaluationMain = () => import('./main')
// 测评人列表
const EvaluationContact = () => import('./contact')
// 问卷答题
const EvaluationQuestionnaire = () => import('./questionnaire')
// 历史问卷
const EvaluationHistory = () => import('./history')
// 上传体检报告
const EvaluationUploadReport = () => import('./uploadReport')
// 问卷结果
const EvaluationResult = () => import('./result')
// 问卷结果
const EvaluationHabitusResult = () => import('./habitusResult')

export default {
  path: '/evaluation',
  component: Evaluation,
  meta: { title: '综合评估' },
  redirect: '/evaluation/main',
  children: [
    {
      path: 'main',
      name: 'EvaluationMain',
      meta: { title: '综合评估' },
      component: EvaluationMain
    },
    {
      path: 'contact',
      name: 'EvaluationContact',
      meta: { title: '选择测评人' },
      component: EvaluationContact
    },
    {
      path: 'questionnaire',
      name: 'EvaluationQuestionnaire',
      meta: { title: '问卷答题' },
      component: EvaluationQuestionnaire
    },
    {
      path: 'history',
      name: 'EvaluationHistory',
      meta: { title: '历史问卷' },
      component: EvaluationHistory
    },
    {
      path: 'upload-report',
      name: 'EvaluationUploadReport',
      meta: { title: '深度评估' },
      component: EvaluationUploadReport
    },
    {
      path: 'result',
      name: 'EvaluationResult',
      meta: { title: '问卷结果' },
      component: EvaluationResult
    },
    {
      path: 'habitus-result',
      name: 'EvaluationHabitusResult',
      meta: { title: '问卷结果' },
      component: EvaluationHabitusResult
    }
  ]
}


// WEBPACK FOOTER //
// ./src/views/evaluation/router.js